import React, { useEffect, useState } from 'react'
import axios from 'axios';
// import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import { handleAllError, handleErrorToast } from '../../CustomFunctions';
import { BASE_URL } from '../../../config/axios';
import { Office, SearchSmall } from '../../AllSvg';
import { AddApprovalFormat, AddDefaultImprestType, DeleteApprovalFormat, DeleteApprovalFormatBackup, DeleteDefaultImprestType, EditAllSettingButton, PayrollCycleRow, RunManualLeaveEncashment, SandwichRuleExplanation, SettingListRow, SettingRow, SetupAllSettingsButton, UpdateApprovalFormat, UpdateDefaultImprestType, ViewApprovalFormatFlow, ViewVersionHistory } from './PortalSettingsComponents';
import { ToastContainer, toast } from "react-toastify";
import usePermission from '../../../config/permissions';
import Loader from '../../Loader';


const PortalBasicSettings = () => {
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUPER_ADMIN, PERMISSION_PORTAL_SETTINGS_EDIT, SUB_COMPANIES } = usePermission();
    const empCode = sessionStorage.getItem('emp_code');
    const userCompanyId = sessionStorage.getItem('company_id');

    // const [settings, setSettings] = useState({
    //     sub_company_id: sessionStorage.getItem('company_id'),
    //     leave_apply_past_limit: "",
    //     leave_apply_future_limit: "",
    //     leave_approval_limit: "",
    //     od_apply_past_limit: "",
    //     od_apply_future_limit: "",
    //     od_approval_limit: "",
    //     arrear_apply_start_limit: "",
    //     arrear_apply_end_limit: "",
    //     weeklyoff_marking_date: "",
    //     holiday_marking_date: "",
    //     probation_conversion_auto_month: "",
    //     currency_symbol: "",
    //     sandwich_rule_enabled: null,
    //     sandwitch_rule: "",
    //     company_change_visibility: "",
    //     show_full_employee_code: null,
    //     arrear_apply_auto: null,
    //     salary_slip_visible: null,
    //     compoff_on_od: null,
    //     direct_emp_creation: null,
    //     portal_setting_leave_increment: [
    //         {
    //             leave_addition_date: null,
    //             leave_addition_type: "",
    //             leave_addition_amount: "",
    //             employee_type: "",
    //         },
    //     ],
    //     portal_setting_leave_encashment: [
    //         {
    //             leave_encashment_type: "",
    //             leave_encashment_date: null,
    //         },
    //     ],
    // });

    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(false);

    console.log('settings')
    console.log(settings)
    const fetchSettings = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${BASE_URL}/wfm/portal_setting_sub_company/${toggleCompany}/`);
            setSettings(response.data);
        } catch (error) {
            handleAllError(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchSettings();
    }, [toggleCompany]);

    const handleSettingUpdate = async (fieldName, newValue) => {
        try {
            setLoading(true);
            await axios.put(`${BASE_URL}/wfm/portal_settings_update/${settings.id}/`, {
                // portal_settings_update_with_logs/<str:pk>/</str:pk>
                [fieldName]: newValue
            });
            setSettings(prev => ({
                ...prev,
                [fieldName]: newValue
            }));
        } catch (error) {
            handleAllError(error);
        } finally {
            setLoading(false);
        }
    };

    const handlePayrollUpdate = async (startDay, endDay) => {
        try {
            setLoading(true);

            await axios.put(
                `${BASE_URL}/wfm/portal_settings_update/${settings.id}/`,
                {
                    payroll_start_date: startDay,
                    payroll_end_date: endDay,
                }
            );

            setSettings(prev => ({
                ...prev,
                payroll_start_date: startDay,
                payroll_end_date: endDay,
            }));
        } catch (error) {
            handleAllError(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading && settings != null) {
        return <>
            <div className="table-css-white-background">Loading Settings...</div>
        </>
    }

    if (settings === null) {
        return <div className="table-css-white-background">
            <div className='flex-row justify-between'>
                <span>No Settings found for {sessionStorage.getItem('company')}</span>
                <SetupAllSettingsButton getSettingsData={fetchSettings} />
            </div>
            <Loader container={true} />
        </div>;
    }




    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Portal Settings</div>
                <div>
                    {(SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT) &&
                        <div className='flex-row'>
                            <div className="table-searchh dropdown-container field-cont-div">
                                <select
                                    onChange={(e) => SUPER_ADMIN && setToggleCompany(e.target.value)}
                                    value={toggleCompany}
                                    className="dropdown font-size-subheading"
                                    disabled={PERMISSION_PORTAL_SETTINGS_EDIT && !SUPER_ADMIN}
                                    style={{ cursor: (PERMISSION_PORTAL_SETTINGS_EDIT && !SUPER_ADMIN) ? 'not-allowed' : 'default' }}
                                >
                                    <option value="null">Select Sub Company</option>
                                    {SUPER_ADMIN ? (
                                        SUB_COMPANIES.map(company => (<option key={company.id} value={company.id}>{company.title}</option>))
                                    ) :

                                        (
                                            SUB_COMPANIES.filter(company => company.id === userCompanyId).map(company => (
                                                <option key={company.id} value={company.id}>{company.title}</option>
                                            ))
                                        )
                                    }
                                </select>
                            </div>
                            <hr className="field-cont-hr" />
                            <EditAllSettingButton setting={settings} getSettingsData={fetchSettings} SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT} />
                        </div>
                    }
                </div>
            </div>

            {settings !== null &&
                <ol>
                    {/* Leave Settings */}
                    <div className='flex-row justify-between'>
                        <h4>Leave Settings</h4>
                        {(SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT) &&
                            <RunManualLeaveEncashment
                                company={toggleCompany}
                                SUB_COMPANIES={SUB_COMPANIES}
                                portalSettings={settings}
                                getDataAPI={fetchSettings}
                            />}
                    </div>
                    <SettingListRow
                        setting={settings}
                        fieldName="portal_setting_leave_increment"
                        label="Leaves Increments"
                        getSettingsData={fetchSettings}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="leave_apply_past_limit"
                        label="Days limit for applying leave (past)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="leave_apply_future_limit"
                        label="Days limit for applying leave (future)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="leave_approval_limit"
                        label="Leave approval limit (days)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="leave_final_bypass"
                        label="Leave Request Bypass by Admin"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingListRow
                        setting={settings}
                        fieldName="portal_setting_leave_encashment"
                        label="Leaves Encashment"
                        getSettingsData={fetchSettings}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />

                    <div className="jd-heading-outer">
                        <div className="jd-heading-bottom-light"></div>
                    </div>

                    {/* Out Duty Settings */}
                    <h4>Out Duty Settings</h4>
                    <SettingRow
                        setting={settings}
                        fieldName="od_apply_past_limit"
                        label="Days limit for applying out duty (past)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="od_apply_future_limit"
                        label="Days limit for applying out duty (future)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="od_approval_limit"
                        label="Out duty approval limit (days)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="od_final_bypass"
                        label="Outduty Request Bypass by Admin"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />

                    <div className="jd-heading-outer">
                        <div className="jd-heading-bottom-light"></div>
                    </div>

                    {/* Payroll Settings */}

                    <div className='flex-row justify-between'>
                        <h4>Payroll Settings</h4>
                    </div>
                    <PayrollCycleRow
                        setting={settings}
                        onUpdate={handlePayrollUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    {/* <SettingRow
                        setting={settings}
                        fieldName="payroll_start_date"
                        label="Payroll Cycle Start Day"
                        fieldType="daypicker"
                        fieldFor="of every month"
                        onUpdate={handleSettingUpdate}
                        required={false}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="payroll_end_date"
                        label="Payroll Cycle End Day"
                        fieldType="daypicker"
                        fieldFor="of every month"
                        onUpdate={handleSettingUpdate}
                        required={false}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    /> */}

                    <div className="jd-heading-outer">
                        <div className="jd-heading-bottom-light"></div>
                    </div>

                    {/* Arrear Settings */}
                    <h4>Arrear Settings</h4>
                    <SettingRow
                        setting={settings}
                        fieldName="arrear_apply_start_limit"
                        label="Arrear apply start limit (days)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="arrear_apply_end_limit"
                        label="Arrear apply end limit (days)"
                        fieldType="number"
                        fieldFor="days"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="arrear_apply_auto"
                        label="Auto apply Arrears"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />

                    <div className="jd-heading-outer">
                        <div className="jd-heading-bottom-light"></div>
                    </div>

                    {/* Date Settings */}
                    <h4>Date Settings</h4>
                    <SettingRow
                        setting={settings}
                        fieldName="weeklyoff_marking_date"
                        label="Weekly off marking date"
                        fieldType="dropdown"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="holiday_marking_date"
                        label="Holiday marking date"
                        fieldType="dropdown"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />

                    <div className="jd-heading-outer">
                        <div className="jd-heading-bottom-light"></div>
                    </div>

                    {/* Employee Settings */}
                    <h4>Employee Settings</h4>
                    <SettingRow
                        setting={settings}
                        fieldName="probation_conversion_auto_month"
                        label="Probation conversion auto month"
                        fieldType="number"
                        fieldFor="months"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="show_full_employee_code"
                        label="Show full employee code"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="direct_emp_creation"
                        label="Allow Direct Employee Add Option"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="emp_details_edit"
                        label="Allow Employee to edit details"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />

                    <div className="jd-heading-outer">
                        <div className="jd-heading-bottom-light"></div>
                    </div>

                    {/* Other Settings */}
                    <h4>Other Settings</h4>
                    <SettingRow
                        setting={settings}
                        fieldName="currency_symbol"
                        label="Currency symbol"
                        fieldType="dropdown"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="sandwich_rule_enabled"
                        label="Sandwich rule Applicable"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    {settings?.sandwich_rule_enabled &&
                        <div className='flex-row'>
                            <SettingRow
                                setting={settings}
                                fieldName="sandwich_holiday_rule"
                                label="Sandwich rule type"
                                fieldType="dropdown"
                                onUpdate={handleSettingUpdate}
                                required={settings?.sandwich_rule_enabled}
                                SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                            />
                            <hr className="field-cont-hr" />
                            <SandwichRuleExplanation settings={settings} />
                        </div>
                    }
                    <SettingRow
                        setting={settings}
                        fieldName="company_change_visibility"
                        label="Company DropDown Visibility"
                        fieldType="dropdown"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="salary_slip_visible"
                        label="Show Salary Slip"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />

                    <SettingRow
                        setting={settings}
                        fieldName="imprest_project_req"
                        label="Project Details in Imprest Mandatory"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        required={true}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="expense_submit_limit"
                        label="Expense Submission Limit Applicable"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    {settings?.expense_submit_limit &&
                        <SettingRow
                            setting={settings}
                            fieldName="expense_submit_limit_days"
                            label="Expense Submission Limit Days"
                            fieldType="number"
                            fieldFor="days"
                            onUpdate={handleSettingUpdate}
                            required={settings?.expense_submit_limit}
                            SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                        />}
                    <SettingRow
                        setting={settings}
                        fieldName="allow_tds_save_if_salary_slip_exists"
                        label="Allow Tax Calculations Save when Pay Slip exists"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="allow_payslip_without_tds"
                        label="Allow Payrun without Tax Calculations"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="eligible_for_shortleave_credit"
                        label="Short leave enabled"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    {settings.eligible_for_shortleave_credit !== false && (
                        <SettingRow
                            setting={settings}
                            fieldName="shortleave_auto_apply"
                            label="Short leave auto apply"
                            fieldType="checkbox"
                            onUpdate={handleSettingUpdate}
                            SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                        />
                    )}
                    <SettingRow
                        setting={settings}
                        fieldName="compoff_auto_apply"
                        label="Comp Off auto apply"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    <SettingRow
                        setting={settings}
                        fieldName="compoff_on_od"
                        label="Comp Off for WeeklyOff OD"
                        fieldType="checkbox"
                        onUpdate={handleSettingUpdate}
                        SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                    />
                    {settings?.compoff_on_od &&
                        <SettingRow
                            setting={settings}
                            fieldName="compoff_od_days_limit"
                            label="Max Limit of OutDuty for Compoff"
                            fieldType="number"
                            fieldFor="days"
                            onUpdate={handleSettingUpdate}
                            required={settings?.compoff_on_od}
                            SUPER_ADMIN={SUPER_ADMIN || PERMISSION_PORTAL_SETTINGS_EDIT}
                        />}
                </ol>}
        </div>
    );
};

const ProcessApprovalFlowSettings = () => {
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const [toggleFormatFor, setToggleFormatFor] = useState('null');
    const [buffer, setBuffering] = useState(true);
    const [approvalFormats, setApprovalFormats] = useState([]);
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getApprovalFormats = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/dynamicapprovals-versionedlist-bysubcompany/${toggleCompany}/${toggleFormatFor}/`);
            setApprovalFormats(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getApprovalFormats();
    }, [toggleCompany, toggleFormatFor]);

    const filteredFormats = approvalFormats.filter((e) =>
        e.format_for?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        e.sub_company_title?.toLowerCase()?.includes(searchQuery.toLowerCase())
    );

    const formatList = [
        { label: "Leave Request", value: "leave" },
        { label: "OutDuty Request", value: "outduty" },
        { label: "Compensatory Request", value: "compensatory" },
        { label: "Imprest Request", value: "imprest" },
        { label: "Expense Request", value: "expense" },
        { label: "Separation Request", value: "separation" },
        { label: "Employee Details Change Request", value: "empDetails" },
        { label: "Bank Details Change Request", value: "bankdetails" },
        { label: "Investment Declaration", value: "investment_declaration" },
        { label: "Investment Proof Justification", value: "investment_proof" },
        { label: "Arrear", value: "arrear" },
    ];

    return (
        <div className="table-css-white-background">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading pl15 mb0">Approval Formats</div>
                <div className="field-cont">
                    {SUPER_ADMIN && (
                        <div className="table-searchh dropdown-container field-cont-div">
                            <Office />
                            <select
                                onChange={(e) => setToggleCompany(e.target.value)}
                                value={toggleCompany}
                                className="dropdown font-size-subheading"
                            >
                                <option value="null">Select SubCompany</option>
                                {SUB_COMPANIES.map(company => (
                                    <option key={company.id} value={company.id}>{company.title}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Format Type Filter */}
                    <div className="table-searchh dropdown-container field-cont-div">
                        <select
                            onChange={(e) => setToggleFormatFor(e.target.value)}
                            value={toggleFormatFor}
                            className="dropdown font-size-subheading"
                        >
                            <option value="null">All Formats</option>
                            {formatList.map(format => (
                                <option key={format.value} value={format.value}>{format.label}</option>
                            ))}
                        </select>
                    </div>

                    <div title="Search" className="table-searchh" style={{ marginRight: "10px" }}>
                        <div>
                            <SearchSmall />
                            <input
                                placeholder="Search by format or company"
                                className="navbar-inputt font-weight400 font-size-text"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>

                    {(toggleCompany !== 'null') && (
                        <AddApprovalFormat
                            existingFormatsList={approvalFormats}
                            getApprovalFormat={getApprovalFormats}
                            SUB_COMPANIES={SUB_COMPANIES}
                            SUPER_ADMIN={SUPER_ADMIN}
                        />
                    )}
                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">Sr. No.</th>
                        <th className="align-center">Company</th>
                        <th className="align-center">Name</th>
                        <th className="align-center">Version</th>
                        <th className="align-center">Status</th>
                        {/* <th className="align-center">Approval Type</th> */}

                        <th className="align-center">Stages</th>
                        <th className="align-center">Previous Versions</th>
                        <th className="align-center">View Current Flow</th>
                        <th className="align-center">Version History</th>
                        <th className="align-right">Action</th>
                    </tr>
                </thead>
                {!buffer && (
                    <tbody>
                        {filteredFormats.map((i, index) => (
                            <React.Fragment key={`${i.format_id}-${i.version}`}>
                                <tr className="tr-border-bottom">
                                    <td colSpan="10"></td>
                                </tr>
                                <tr className={`custom-table-head-td ${!i.is_active ? 'inactive-flow-row' : ''}`}>
                                    <td className="align-left">{index + 1}</td>
                                    <td className="align-center">{i.sub_company_title}</td>
                                    <td className="align-center">
                                        {formatList.find(f => f.value === i.format_for)?.label || i.format_for}
                                    </td>
                                    <td className="align-center">
                                        <strong>v{i.version}</strong>
                                        {/* {i.is_active && (

                                            // <div className="active-badge">Active</div>
                                            <button className="priority-button color-tab-green">
                                                Active
                                            </button>
                                        )} */}
                                    </td>
                                    <td className="align-center">
                                        <span className={`status-badge ${i.is_active ? 'status-active' : 'status-inactive'}`}>
                                            {i.is_active ?
                                                // 'Active' 
                                                <button className="priority-button color-tab-green">
                                                    Active
                                                </button>
                                                :
                                                // 'Inactive'
                                                <button className="priority-button color-tab-red">
                                                    Inactive
                                                </button>
                                            }
                                        </span>
                                    </td>
                                    {/* <td className="align-center">
                                        {i.stages_count === 0 && i.is_active ? (
                                            <span className="priority-button color-tab-green">
                                                Direct_Approval
                                            </span>
                                        ) : (
                                            <span className="priority-button color-tab-blue">
                                                Flow Based
                                            </span>
                                        )}
                                    </td> */}

                                    <td className="align-center">
                                        {i.stages_count === 0 && i.is_active ?
                                            (
                                                <span className="priority-button color-tab-blue" style={{ display: 'block', width: 'max-content' }}>
                                                    Direct Approval
                                                </span>
                                            )
                                            :
                                            <>
                                                <span className="priority-button color-tab-teal" style={{ display: 'block', width: 'max-content' }}>
                                                    Flow Stages : {i.stages_count}
                                                </span>
                                            </>
                                        } </td>
                                    <td className="align-center">
                                        {i.previous_versions_count > 0 ? (
                                            <span className="version-count-badge">
                                                {i.previous_versions_count} version{i.previous_versions_count !== 1 ? 's' : ''}
                                            </span>
                                        ) : (
                                            'None'
                                        )}
                                    </td>
                                    <td className="align-center width-5vw">
                                        <ViewApprovalFormatFlow i={i} />
                                    </td>
                                    <td className="align-center width-5vw">
                                        {/* ✅ New Version History Button */}
                                        <ViewVersionHistory
                                            formatData={i}
                                            formatList={formatList}
                                        />
                                    </td>
                                    <td className="text-right width-5vw">
                                        <div className="flex-row justify-end">
                                            <UpdateApprovalFormat
                                                i={i}
                                                getApprovalFormat={getApprovalFormats}
                                                SUPER_ADMIN={SUPER_ADMIN}
                                                SUB_COMPANIES={SUB_COMPANIES}
                                            />
                                            {/* <DeleteApprovalFormatBackup
                                                i={i}
                                                getApprovalFormat={getApprovalFormats}
                                            /> */}
                                            <DeleteApprovalFormat
                                                i={i}
                                                getApprovalFormat={getApprovalFormats}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                )}
            </table>
            {buffer && <Loader container={true} />}
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

const ImprestFormatTable = () => {

    const [buffer, setBuffering] = useState(false);
    const [imprestTypeFormat, setImprestTypeFormat] = useState([]);
    // const [toggleCompany, setToggleCompany] = useState('null');
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getImprestTypeFormat = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(`${BASE_URL}/wfm/imprest_type_format_subcompany/${toggleCompany}/`);
            setImprestTypeFormat(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getImprestTypeFormat();
    }, [toggleCompany]);

    return (
        <div>
            <div className="table-css-white-background">
                <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
                    <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
                        <div className="repo-heading font-weight500    font-size-heading pl15 mb0">
                            Imprest Default Types
                        </div>
                        <div className="field-cont">
                            {SUPER_ADMIN && <div title="Select SubCompany" className="table-searchh dropdown-container field-cont-div">
                                <Office />
                                <select
                                    value={toggleCompany}
                                    onChange={(e) => setToggleCompany(e.target.value)}
                                    className="dropdown font-size-subheading  "
                                    style={{ cursor: "pointer" }}
                                >
                                    <option value="null">Select SubCompany</option>
                                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                </select>
                            </div>}
                            <div title='Search' className="table-searchh">
                                <div>
                                    <SearchSmall />
                                    <input
                                        placeholder="Search"
                                        className="navbar-inputt font-weight400  font-size-text"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                            </div>
                            <AddDefaultImprestType getImprestTypeFormat={getImprestTypeFormat} SUB_COMPANIES={SUB_COMPANIES} SUPER_ADMIN={SUPER_ADMIN} />
                        </div>
                    </div>
                    <div className='table-box  scroll-container-table' style={{ width: "100%" }}>
                        <table className="table-css" >
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.no.</th>
                                    <th className="table-heading-text text-center">Sub Company</th>
                                    <th className="table-heading-text text-center">Imprest Type Name</th>
                                    <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>//buffering logic
                            ) : (
                                <tbody>
                                    {imprestTypeFormat
                                        ?.filter((e) =>
                                            e.other_name.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .sort((a, b) =>
                                            a.other_name?.localeCompare(b.other_name, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .sort((a, b) =>
                                            a.sub_company_title?.localeCompare(b.sub_company_title, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="custom-table-head-td ">
                                                    <td className="table-body ">{index + 1}</td>
                                                    <td className="table-body text-center">{i.sub_company_title}</td>
                                                    <td className="table-body text-center ">{i.other_name}</td>
                                                    <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                                                        <div className='flex-row justify-end'>
                                                            <UpdateDefaultImprestType
                                                                i={i}
                                                                getImprestTypeFormat={getImprestTypeFormat}
                                                                SUB_COMPANIES={SUB_COMPANIES}
                                                            />
                                                            <DeleteDefaultImprestType
                                                                i={i}
                                                                getImprestTypeFormat={getImprestTypeFormat} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}


export {
    PortalBasicSettings,
    ProcessApprovalFlowSettings,
    ImprestFormatTable,
}
